import IntelHeader from "../components/layout/accounts-header/account-header";
import ErrorImage from "./../assets/images/error.svg";
import "./../assets/scss/global.scss";
import "./../routes/accounts/accounts.scss";
export default function ResetPassword() {
  return (
    <div>
      <IntelHeader />
      <div className="container">
        <div className="d-block text-center py-5">
          <img className="img-fluid" src={ErrorImage} alt="Trademo" />
          <p style={{ fontSize: "16px" }}>
            Page not found, please
            <span
              className="trademo-link ml-2 cursor-pointer"
              onClick={() => {
                window.history.go(-1);
              }}
            >
              <strong>Go Back</strong>
            </span>
          </p>
        </div>
      </div>
      <div className="footer-sticky-bottom py-2">
        <p className="mb-0">
          <small>©Trademo Technologies Inc.</small>
        </p>
      </div>
    </div>
  );
}
